import { render, staticRenderFns } from "./logistics-create.vue?vue&type=template&id=62c074b2&"
import script from "./logistics-create.vue?vue&type=script&lang=ts&"
export * from "./logistics-create.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports